var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3 flex-wrap"},[_c('h3',{staticClass:"m-0"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"options"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }